import { HalResource } from '../hal/models/HalResource';
import { HierarchyNode } from './HierarchyNode';
import { ContentItem } from './ContentItem';
export class HierarchyChildren extends HalResource {
    constructor(data) {
        super(data);
        this.related = {
            contentItem: {
                /**
                 * Retrieve the content item associated with this node
                 */
                get: () => this.fetchLinkedResource('content-item', {}, ContentItem),
            },
        };
        this.children = this.children.map((node) => new HierarchyNode(node));
    }
    setClient(client) {
        this.client = client;
        this.children.forEach((child) => {
            child.setClient(client);
        });
    }
    toJson() {
        return this.toJSON();
    }
    toJSON() {
        return Object.assign(super.toJSON(), {
            children: this.children.map((parent) => parent.toJSON()),
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGllcmFyY2h5Q2hpbGRyZW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL21vZGVsL0hpZXJhcmNoeUNoaWxkcmVuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSwyQkFBMkIsQ0FBQztBQUN4RCxPQUFPLEVBQXNCLGFBQWEsRUFBRSxNQUFNLGlCQUFpQixDQUFDO0FBRXBFLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFVNUMsTUFBTSxPQUFPLGlCQUFrQixTQUFRLFdBQVc7SUFZaEQsWUFBWSxJQUF3QjtRQUNsQyxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7UUF1QlAsWUFBTyxHQUFHO1lBQ2YsV0FBVyxFQUFFO2dCQUNYOzttQkFFRztnQkFDSCxHQUFHLEVBQUUsR0FBeUIsRUFBRSxDQUM5QixJQUFJLENBQUMsbUJBQW1CLENBQUMsY0FBYyxFQUFFLEVBQUUsRUFBRSxXQUFXLENBQUM7YUFDNUQ7U0FDRixDQUFDO1FBN0JBLElBQUksQ0FBQyxRQUFRLEdBQUcsSUFBSSxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUMsQ0FBQyxJQUFJLEVBQUUsRUFBRSxDQUFDLElBQUksYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUM7SUFDdkUsQ0FBQztJQUVELFNBQVMsQ0FBQyxNQUFpQjtRQUN6QixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQztRQUVyQixJQUFJLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxDQUFDLEtBQUssRUFBRSxFQUFFO1lBQzlCLEtBQUssQ0FBQyxTQUFTLENBQUMsTUFBTSxDQUFDLENBQUM7UUFDMUIsQ0FBQyxDQUFDLENBQUM7SUFDTCxDQUFDO0lBRUQsTUFBTTtRQUNKLE9BQU8sSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDO0lBQ3ZCLENBQUM7SUFFRCxNQUFNO1FBQ0osT0FBTyxNQUFNLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxNQUFNLEVBQUUsRUFBRTtZQUNuQyxRQUFRLEVBQUUsSUFBSSxDQUFDLFFBQVEsQ0FBQyxHQUFHLENBQUMsQ0FBQyxNQUFNLEVBQUUsRUFBRSxDQUFDLE1BQU0sQ0FBQyxNQUFNLEVBQUUsQ0FBQztTQUN6RCxDQUFDLENBQUM7SUFDTCxDQUFDO0NBV0YifQ==